/** @jsxImportSource @emotion/react */
import {
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '../../../../components/Dialog';
import {Dialog} from '@reach/dialog';
import Img from './FailImg.svg';
import Button, {ButtonGroup} from '../../../../components/Button';

export type Props = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen?: boolean;
  text?: React.ReactNode;
};
export default function NoticeDialog(props: Props) {
  const {isOpen, text, onCancel, onConfirm} = props;
  return (
    <Dialog isOpen={isOpen} className={'notice-dialog'} aria-label="notice-dialog">
      <DialogTitle title="提醒" onClose={onCancel} showCloseButton />
      <DialogContent>
        <p css={{marginTop: 16, fontSize: 15, lineHeight: 2}}>
          {text}
        </p>
        <img
          alt="noticeImg"
          src={Img}
          css={{marginTop: 15, marginBottom: 40, marginRight: 40, marginLeft: 40 }}
        />
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
          <Button variant={'cta'} onClick={onConfirm} className={'confirm-btn'} aria-label="confirm-btn">
            確定
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </Dialog>
  );
}
